import TaggedText from './TaggedText';
export default TaggedText;
